
const API_BASE_URL ="/api";
  // process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";

export const submitHotelSuggestion = async ({
  name,
  email,
  query,
}) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/entertainment-inquiry/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          query,
        }),
      }
    );

    const responseText = await response.text();
    let data;

    try {
      data = JSON.parse(responseText);
    } catch {
      console.error("Non-JSON API response:", {
        status: response.status,
        response: responseText.slice(0, 500),
      });

      throw new Error(
        `Invalid server response (HTTP ${response.status}).`
      );
    }

    if (!response.ok) {
      const firstError = Object.values(data).find(
        (value) => Array.isArray(value) && value.length
      )?.[0];

      throw new Error(
        firstError ||
          data.detail ||
          data.error ||
          "Failed to submit hotel suggestion."
      );
    }

    return data;
  } catch (error) {
    console.error("Hotel Suggestion API Error:", error);
    throw error;
  }
};
